// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== AWS Sticky Top Banner ===== */
/* Uses design tokens from Technum.css :root */
.aws-banner {
  background: linear-gradient(90deg, var(--technum-aws-dark) 0%, var(--technum-aws-mid) 50%, var(--technum-aws-dark) 100%);
  color: var(--technum-white);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--technum-space-sm) var(--technum-space-md);
  font-family: var(--font-heading);
  position: relative;
  z-index: 999;
  animation: awsBannerSlideDown 0.4s ease-out;
}

@keyframes awsBannerSlideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.aws-banner-inner {
  display: flex;
  align-items: center;
  gap: var(--technum-space-sm);
  flex-wrap: wrap;
  justify-content: center;
}

.aws-banner-badge {
  background: var(--technum-aws-orange);
  color: var(--technum-aws-navy);
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 3px 10px;
  border-radius: var(--technum-radius-sm);
}

.aws-banner-text {
  font-size: var(--caption);
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.aws-banner-link {
  display: inline-flex;
  align-items: center;
  gap: var(--technum-space-xs);
  color: var(--technum-aws-orange);
  font-size: var(--caption);
  font-weight: 700;
  text-decoration: none;
  transition: gap 0.2s ease;
}

.aws-banner-link:hover {
  gap: var(--technum-space-sm);
  color: var(--technum-aws-orange-light);
}

.aws-banner-close {
  position: absolute;
  right: var(--technum-space-sm);
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  padding: var(--technum-space-xs);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}

.aws-banner-close:hover {
  color: var(--technum-white);
}

/* ===== RESPONSIVE: 480px ===== */
@media (max-width: 480px) {
  .aws-banner-text {
    display: none;
  }

  .aws-banner {
    padding: 6px 40px 6px var(--technum-space-sm);
  }
}

/* ===== RESPONSIVE: 360px ===== */
@media (max-width: 360px) {
  .aws-banner {
    padding: 4px 36px 4px var(--technum-space-xs);
  }

  .aws-banner-badge {
    font-size: 10px;
    padding: 2px 8px;
  }

  .aws-banner-link {
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AwsBanner/AwsBanner.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC,8CAA8C;AAC9C;EACE,wHAAwH;EACxH,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE;IACE,aAAa;EACf;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,6CAA6C;EAC/C;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ===== AWS Sticky Top Banner ===== */\n/* Uses design tokens from Technum.css :root */\n.aws-banner {\n  background: linear-gradient(90deg, var(--technum-aws-dark) 0%, var(--technum-aws-mid) 50%, var(--technum-aws-dark) 100%);\n  color: var(--technum-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--technum-space-sm) var(--technum-space-md);\n  font-family: var(--font-heading);\n  position: relative;\n  z-index: 999;\n  animation: awsBannerSlideDown 0.4s ease-out;\n}\n\n@keyframes awsBannerSlideDown {\n  from {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.aws-banner-inner {\n  display: flex;\n  align-items: center;\n  gap: var(--technum-space-sm);\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.aws-banner-badge {\n  background: var(--technum-aws-orange);\n  color: var(--technum-aws-navy);\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 3px 10px;\n  border-radius: var(--technum-radius-sm);\n}\n\n.aws-banner-text {\n  font-size: var(--caption);\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.aws-banner-link {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--technum-space-xs);\n  color: var(--technum-aws-orange);\n  font-size: var(--caption);\n  font-weight: 700;\n  text-decoration: none;\n  transition: gap 0.2s ease;\n}\n\n.aws-banner-link:hover {\n  gap: var(--technum-space-sm);\n  color: var(--technum-aws-orange-light);\n}\n\n.aws-banner-close {\n  position: absolute;\n  right: var(--technum-space-sm);\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n  padding: var(--technum-space-xs);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s ease;\n}\n\n.aws-banner-close:hover {\n  color: var(--technum-white);\n}\n\n/* ===== RESPONSIVE: 480px ===== */\n@media (max-width: 480px) {\n  .aws-banner-text {\n    display: none;\n  }\n\n  .aws-banner {\n    padding: 6px 40px 6px var(--technum-space-sm);\n  }\n}\n\n/* ===== RESPONSIVE: 360px ===== */\n@media (max-width: 360px) {\n  .aws-banner {\n    padding: 4px 36px 4px var(--technum-space-xs);\n  }\n\n  .aws-banner-badge {\n    font-size: 10px;\n    padding: 2px 8px;\n  }\n\n  .aws-banner-link {\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
